import React from 'react'
import Button from '@Components/Buttons/Button'

interface DownloadSidebarSubmittedProps {
    closeSidebar: () => void
    subText: string
}

const DownloadSidebarSubmitted = (props: DownloadSidebarSubmittedProps) => (
    <>
        <h2>Your files are on the way!</h2>
        <p className="large">{props.subText}</p>
        <div className="download-button">
            <Button mainColor type="primary" onClick={() => props.closeSidebar()}>
                Done
            </Button>
        </div>
    </>
)

export default DownloadSidebarSubmitted
